import axios from 'axios'
import * as types from './types'

const BASE = '/api/commissions/snapshot_change_requests'
const APPROVERS = '/api/commissions/snapshot_approvers'

export default {
  [types.OPEN_REQUEST_SIDEBAR]: ({ commit }, payload) => {
    commit(types.MUTATE_REQUEST_SIDEBAR, { ...payload, visible: true })
  },
  [types.SEARCH_REQUESTS]: ({ commit }, payload) => {
    const params = { ...payload }

    return axios.get(BASE, { params })
      .then(resp => {
        commit(types.MUTATE_REQUESTS_SEARCH_RESULT, resp.data)
        return Promise.resolve(resp)
      })
      .catch(err => Promise.reject(err))
  },
  [types.GET_REQUESTS_BY_CONTRACT]: (context, payload) => axios
    .get(`${BASE}/contract/${payload.contractId}`, { params: payload.params || {} })
    .then(resp => Promise.resolve(resp))
    .catch(err => Promise.reject(err)),
  [types.CREATE_REQUEST]: (context, payload) => axios
    .post(`${BASE}/contract/${payload.contractId}`, payload.body)
    .then(resp => Promise.resolve(resp))
    .catch(err => Promise.reject(err)),
  [types.UPDATE_REQUEST_STATUS]: (context, payload) => axios
    .post(`${BASE}/update_status/${payload.id}`, {
      status: payload.status,
      review_notes: payload.reviewNotes || undefined,
    })
    .then(resp => Promise.resolve(resp))
    .catch(err => Promise.reject(err)),
  [types.OPEN_APPROVER_SIDEBAR]: ({ commit }, payload) => {
    commit(types.MUTATE_APPROVER_SIDEBAR, { ...payload, visible: true })
  },
  [types.SEARCH_APPROVERS]: ({ commit }, payload) => {
    const params = { ...payload }

    return axios.get(APPROVERS, { params })
      .then(resp => {
        commit(types.MUTATE_APPROVERS_SEARCH_RESULT, resp.data)
        return Promise.resolve(resp)
      })
      .catch(err => Promise.reject(err))
  },
  [types.GET_APPROVER_CANDIDATES]: () => axios
    .get(`${APPROVERS}/candidates`)
    .then(resp => Promise.resolve(resp))
    .catch(err => Promise.reject(err)),
  [types.ADD_APPROVER]: (context, payload) => axios
    .post(APPROVERS, { user_id: payload })
    .then(resp => Promise.resolve(resp))
    .catch(err => Promise.reject(err)),
  [types.REMOVE_APPROVER]: (context, payload) => axios
    .delete(`${APPROVERS}/${payload}`)
    .then(resp => Promise.resolve(resp))
    .catch(err => Promise.reject(err)),
  [types.GET_APPROVERS_HISTORY]: (context, payload) => axios
    .get(`${APPROVERS}/history`, { params: { ...payload } })
    .then(resp => Promise.resolve(resp))
    .catch(err => Promise.reject(err)),
}
